const SECTIONS = {
    MARKET_PLACE: 'MarketPlace',
    DIGITAL_SPENDS: 'Digital Spends',
    SOCIAL_WATCH: 'Socialwatch',
    ORGANIC_PERFORMANCE: 'Organic Performance',
};

// Don't change the order of sections here
const SECTIONS_ORDER = [
    SECTIONS.MARKET_PLACE,
    SECTIONS.DIGITAL_SPENDS,
    SECTIONS.SOCIAL_WATCH,
    SECTIONS.ORGANIC_PERFORMANCE,
];

export {
    SECTIONS_ORDER,
};
